module.exports = "<ul class=ui-select-no-choice ng-if=$select.items.length> <li ng-transclude></li> </ul> ";